export const IMAGES = {
  logo: require('./logo.png'),
  userPlaceholder: require('./user-placeholder.png')
};

export const LOTTIE = {
  notFound1: require('./lottie/page-not-found-1.json'),
  notFound2: require('./lottie/page-not-found-2.json'),
  notFound3: require('./lottie/page-not-found-3.json'),
  notFound4: require('./lottie/page-not-found-4.json')
};

export const getNotFoundLottie = () => {
  const lotties = [LOTTIE.notFound1, LOTTIE.notFound2, LOTTIE.notFound3, LOTTIE.notFound4];
  return lotties[Math.floor(Math.random() * lotties.length)];
};
